<template>
  <VContainer
    fluid
    class="pt-0 pa-lg-0 pb-6"
    data-testid="newsletterSignupContainer"
  >
    <!-- Success State -->
    <template v-if="isSubscribed">
      <VRow no-gutters :justify="isMdAndDown ? 'center' : 'start'">
        <VCol cols="12">
          <VRow no-gutters>
            <VCol cols="12" class="pb-3">
              <h3 class="signup-header">
                {{ $t('newsletter.p.subscribedConfirmation') }}
              </h3>
            </VCol>
            <VCol cols="12" class="pb-3">
              {{ $t('newsletter.p.checkEmail') }}
            </VCol>
          </VRow>
        </VCol>
      </VRow>
    </template>

    <!-- Default Form State -->
    <template v-else>
      <ObservedForm
        noerror
        @submit="submit"
      >
        <SLoadingOverlay :loading="loading" />
        <VRow no-gutters :justify="isMdAndDown ? 'center' : 'start'">
          <VCol cols="12">
            <VRow no-gutters>
              <VCol cols="12" class="pb-3">
                <h3 class="signup-header">
                  {{ $t('newsletter.signup.header') }}
                </h3>
              </VCol>
            </VRow>
          </VCol>
          <VCol cols="9" sm="5" lg="7" class="mr-3">
            <TextFieldWithValidation
              v-model="email"
              :hide-details-without-error="true"
              :label="$t('label.email')"
              rules="required|email"
              name="newsletter-email"
              autocomplete="email"
              required
              data-testid="newsletter-email-field"
            />
          </VCol>
          <VCol sm="auto">
            <SBtn
              type="submit"
              action
              block
              color="primary"
              height="46"
              data-testid="newsletter-submit-button"
            >
              {{ $t('label.signUp') }}
            </SBtn>
          </VCol>
        </VRow>
      </ObservedForm>
    </template>
  </VContainer>
</template>

<script setup lang="ts">
import TextFieldWithValidation from '~/components/base/fields/TextFieldWithValidation.vue'
import ObservedForm from '~/components/base/ObservedForm.vue'
import { useAccountStore } from '~/stores/account'
import { useBreakpoints } from '~/composables/display'

const accountStore = useAccountStore()

const { loading, processAction } = useAction()

const { breakpoints } = useBreakpoints()
const isMdAndDown = computed(() => unref(breakpoints.mdAndDown))

const email = ref('')
const isSubscribed = ref(false)

const submit = async () => {
  await processAction(async () => {
    await accountStore.signUpNewsletter(email.value)
    isSubscribed.value = true
  })
}
</script>

<style lang="scss" scoped>
.signup-header {
  color: rgb(var(--v-theme-primary));
}

:deep(.v-messages__message) {
  background-color: white;
  padding: 8px;
}
</style>
